import React, { useEffect } from 'react';
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';

const AddressRow = (props) => {
    const [servicestypes, setServicesTypes] = React.useState([]);
    const { width } = useViewPort();
    const breakpoint = 620;

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes([]);
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
        }
    }

    React.useEffect(() => {
        GetServicesTypes();
    }, []);

    return (
        <tr key="id">
            <td className="cell_hidden">{props.address.id}</td>
            <td className="cell_hidden">{props.address.idUserAddress}</td>
            {servicestypes.filter(item => item.idServiceType === props.address.idServiceType).map(types => (
                <td style={{ textAlign: "center" }} key={types.idServiceType}>
                    {types.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />
                    }
                </td>
            ))}
            <td>{props.address.idServiceType !== 10 ? props.address.addressValue :
                (props.address.idServiceType === 10 && props.address.addressValue === "") ? <div style={{ color: "red" }}>Not Actived, set on App</div> :
                    <div style={{ color: "#27ac27" }}>Active</div>}</td>
            <td>{props.address.addressOption}</td>
            <td>
                <button type='button' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px" } : { backgroundColor: "#0099CC", }} onClick={() => props.onRequestEditAddress(props.address.id)} disabled={props.address.idServiceType === 10 ? true : false}><FaIcons.FaRegEdit style={{ height: '20px' }} /></button> &nbsp;
                <button type='button' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px" } : { backgroundColor: "#0099CC", }} onClick={() => props.onRequestDeleteAddress(props.address.id)}><FaIcons.FaRegTrashAlt style={{ height: '20px' }} disabled={props.address.idServiceType === 10 ? true : false} /></button>
            </td>
        </tr>
    )
}

export { AddressRow };